// vc-persistent-cart.js
(function () {
  const LOG = false;
  const log = (...a) => LOG && console.log('[PersistentCart]', ...a);

  const BACKEND = window.VEDHACART_CONFIG.serverUrl;

  function isLoggedIn() {
    return !!window.VC_CUSTOMER_ID;
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }

  // Save current cart snapshot into metafield via backend
  async function saveCartSnapshot() {
    if (!isLoggedIn()) return;

    try {
      const cart = await fetchCart();
      if (!cart || !Array.isArray(cart.items)) return;

      await fetch(`${BACKEND}/cart/save`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          customerId: window.VC_CUSTOMER_ID,
          items: cart.items,
        }),
      });

      log('Saved cart snapshot for customer', window.VC_CUSTOMER_ID);
    } catch (e) {
      console.warn('[PersistentCart] save failed', e);
    }
  }

  // Restore cart from metafield if current cart is empty
  async function restoreCartIfEmpty() {
    if (!isLoggedIn()) return;

    try {
      const cart = await fetchCart();
      if ((cart.item_count || 0) > 0) {
        log('Cart not empty, no restore needed');
        return;
      }

      const res = await fetch(
        `${BACKEND}/cart/load?customerId=${encodeURIComponent(
          window.VC_CUSTOMER_ID
        )}`,
        { credentials: 'same-origin' }
      );

      if (!res.ok) {
        log('No persisted cart to restore (HTTP ' + res.status + ')');
        return;
      }

      const saved = await res.json();
      if (!Array.isArray(saved) || !saved.length) {
        log('No items in persisted cart');
        return;
      }

      log('Restoring cart from persisted snapshot', saved);

      // Just in case, clear cart first (should already be empty)
      await fetch('/cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
      });

      // Add each item back
      for (const it of saved) {
        const variantId = String(it.variantId || it.variant_id);
        const qty = String(it.quantity || it.qty || 1);

        const body = new URLSearchParams({
          id: variantId,
          quantity: qty,
        }).toString();

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/x-www-form-urlencoded; charset=UTF-8',
            Accept: 'application/json',
          },
          credentials: 'same-origin',
          body,
        }).then((r) => r.json());
      }

      // Let existing listeners (cart drawer / header badge) refresh
      document.dispatchEvent(new Event('vc:cart:updated'));
    } catch (e) {
      console.warn('[PersistentCart] restore failed', e);
    }
  }

  // Whenever the cart changes, save a snapshot
  document.addEventListener('cart:updated', () => {
    if (!isLoggedIn()) return;
    saveCartSnapshot();
  });

  document.addEventListener('vc:cart:updated', () => {
    if (!isLoggedIn()) return;
    saveCartSnapshot();
  });

  // Clear saved cart (e.g., after successful checkout)
  async function clearSavedCart() {
    if (!isLoggedIn()) return;

    try {
      await fetch(`${BACKEND}/cart/save`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          customerId: window.VC_CUSTOMER_ID,
          items: [],
        }),
      });

      log('Cleared saved cart for customer', window.VC_CUSTOMER_ID);
    } catch (e) {
      console.warn('[PersistentCart] clear failed', e);
    }
  }

  // Check if we just came back from checkout (cart was cleared by Shopify)
  // and URL contains order confirmation params
  function detectCheckoutReturn() {
    const urlParams = new URLSearchParams(window.location.search);

    // Shopify redirect URLs often contain 'checkout_url' or the cart will be empty after checkout
    // We can also check if there's an order ID in the URL
    const hasOrderParam = urlParams.has('order') ||
                          urlParams.has('order_id') ||
                          urlParams.has('checkout');

    // Check if we're on thank you / order status page
    const isOrderStatusPage = window.location.pathname.includes('/orders/') ||
                              window.location.pathname.includes('/thank') ||
                              window.location.pathname.includes('/checkouts/');

    return hasOrderParam || isOrderStatusPage;
  }

  // Check if customer has a recent order (within last 5 minutes) - indicates checkout just completed
  async function hasRecentOrder() {
    if (!isLoggedIn()) return false;

    try {
      const res = await fetch(`${BACKEND}/api/proxy/customer/recent-order?customerId=${encodeURIComponent(window.VC_CUSTOMER_ID)}`);
      if (!res.ok) return false;

      const data = await res.json();
      return data.hasRecentOrder === true;
    } catch (e) {
      log('Error checking recent order:', e);
      return false;
    }
  }

  // On first load as a logged-in customer
  document.addEventListener('DOMContentLoaded', async () => {
    if (!isLoggedIn()) return;

    // If we just returned from checkout, clear the saved cart instead of restoring
    if (detectCheckoutReturn()) {
      log('Detected checkout return, clearing saved cart');
      await clearSavedCart();
      return;
    }

    // Before restoring, check if there's a recent order (checkout completed recently)
    // This handles cases where user doesn't land on thank you page
    const cart = await fetchCart();
    if ((cart.item_count || 0) === 0) {
      const recentOrder = await hasRecentOrder();
      if (recentOrder) {
        log('Recent order detected, clearing saved cart instead of restoring');
        await clearSavedCart();
        return;
      }
    }

    // Otherwise, try to restore if empty
    restoreCartIfEmpty();
  });

  // Expose clearSavedCart globally for manual clearing if needed
  window.VC_clearSavedCart = clearSavedCart;
})();
